import { render } from "./AddNoteForm.vue?vue&type=template&id=cce81ea8&scoped=true"
import script from "./AddNoteForm.vue?vue&type=script&lang=js"
export * from "./AddNoteForm.vue?vue&type=script&lang=js"

import "./AddNoteForm.vue?vue&type=style&index=0&id=cce81ea8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cce81ea8"]])

export default __exports__